export class ActiveChildVaccination {
	id: number = 0;
	citizenExtraId: number = 0;
	fullName?: string;
	phone?: string;
	identifier?: string;
	birthdate?: string;
	age?: string;
	ageInDays?: string;
	gender?: string;
	uf?: string;
	city?: string;
	cep?: string;
	neighborhood?: string;
	street?: string;
	houseNumber?: string;
	cns?: string;
	countRegisters: number = 0;
}
